module.exports = __webpack_public_path__ + "img/box2_logo.cd2e8791.png";